import React from "react";
import ModalFormMetodo from "./ModalFormMetodo";

const ModalMetodo = ({ show, handleClose, metodo }) => {
  return (
    <ModalFormMetodo show={show} handleClose={handleClose} metodo={metodo} />
  );
};

export default ModalMetodo;
